import { isUserAdmin, isUserSupport, chargeControlMode } from "constant";
import CheckIcon from "@mui/icons-material/Check";
import BoltIcon from "@mui/icons-material/Bolt";
import Typography from "@mui/material/Typography";
import BatteryIcon from "assets/svgIcons/BatteryIcon";
import UnKnowIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/UnKnownIcon";
import BatteryWithPowerIcon from "assets/svgIcons/BatteryWithPowerIcon";
import OnChargeIcon from "assets/svgIcons/MapLegendPopup/BatteryStatus/OnCharge";
import { batteryOK } from "_helperFunctions/batteryOK";
import { batteryCritical } from "_helperFunctions/batteryCritical";
import { batteryWarning } from "_helperFunctions/batteryWarning";
import { batteryLevel } from "_helperFunctions/batteryLevel";

export function RenderBatteryColumn({ car, canCommunicate, userRole, getPrivilegeAction, privilege, getChargeHistoryAction }) {
  if (!car) return null;
  const carNumber = car?.CarNumber;
  const chargeHistory = getChargeHistoryAction?.find?.(c => c.CarNumber === carNumber);
  const prv = getPrivilegeAction ? getPrivilegeAction[privilege] : undefined;
  const adminSupportservice = (isUserAdmin(userRole) || isUserSupport(userRole) || prv);
  const hasChargeHistory = adminSupportservice && Boolean(chargeHistory?.ChargeEvents?.length);

  // Battery color helpers
  const batteryColor = (car) => {
    if (!car.UseVoltage) {
      if (car.IsCharging) {
        if ((car.BatteryLevel >= 80) && (car.BatteryLevel <= 100)) return 'green';
      } else {
        if (batteryCritical(car)) return 'red';
        if (batteryWarning(car)) return 'orange';
        if (batteryOK(car)) return 'green';
      }
    }
    return 'black';
  };

  const chargeBoltColor = (car) => {
    if (car.ChargeControlMode === undefined) return 'black';
    if (car.ChargeControlMode === chargeControlMode.Inhibited) {
      return 'red';
    }
    if ((car.BatteryLevel >= 80) && (car.BatteryLevel <= 100)) {
      return 'green';
    }
    return 'black';
  };

  // Render logic as per renderCell
  return (
    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      {canCommunicate && (
        <>
          {!hasChargeHistory && (
            <>
              {!adminSupportservice && batteryOK(car) && (
                <CheckIcon sx={{ color: 'green', fontSize: 18, mr: 0.5 }} />
              )}
              <Typography variant="body2" component="span" sx={{ color: batteryColor(car), fontWeight: 500 }}>
                {batteryLevel(car,adminSupportservice)}
              </Typography>
              {car?.IsCharging && (
                <BoltIcon sx={{ color: chargeBoltColor(car), fontSize: 25, ml: 0.5 }} />
              )}
            </>
          )}
        </>
      )}
      {car?.UseVoltage && !car.CanCarCommunicate && (
        <Typography variant="body2" component="span" className="fleetBatteryString" sx={{ color: (car?.UseVoltage && batteryCritical(car)) ? 'red' : 'black', fontWeight: 500 }}>
          {batteryLevel(car,adminSupportservice)}
        </Typography>
      )}
    </span>
  );
}

function RenderBatteryIcon({ car }) {
  const redLevel = car.BatteryLevel <= 10;
  const yellowLevel = car.BatteryLevel > 10 && car.BatteryLevel < 26;
  const greenLevel = car.BatteryLevel > 25 && car.BatteryLevel <= 100;
  const unknownLevel = car.BatteryLevel > 100;

  if (car.IsCharging) {
    if (car.BatteryLevel >= 95) return <BatteryWithPowerIcon />;
    else return <OnChargeIcon width={37} height={22} />;
  } else {
    if (redLevel) {
      return <BatteryIcon color="#FA3C30" />;
    } else if (greenLevel) {
      return <BatteryIcon color="#00A692" />;
    } else if (yellowLevel) {
      return <BatteryIcon color="#FFD707" />;
    } else if (unknownLevel) {
      // return <BatteryIcon width={18.5} height={10} color="#FFF" />;
      return <UnKnowIcon width={40} height={24} />;
    } else {
      return <span>no Icon available</span>;
    }
  }
}

export default RenderBatteryIcon;
